import { onCLS, onFCP, onLCP, onTTFB, type Metric } from 'web-vitals';
import * as Sentry from '@sentry/react';

export function reportWebVitals() {
  onCLS((metric) => sendMetricToSentry(metric));
  onFCP((metric) => sendMetricToSentry(metric));
  onLCP((metric) => sendMetricToSentry(metric));
  onTTFB((metric) => sendMetricToSentry(metric));
}

function sendMetricToSentry(metric: Metric) {
  Sentry.captureMessage(`Web Vital: ${metric.name} = ${metric.value.toFixed(2)}`, {
    level: 'info',
    tags: {
      'web-vital': metric.name,
      'web-vital-rating': metric.rating || 'unknown',
    },
    contexts: {
      'web-vital': {
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
      },
    },
  });
}
